import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Image, Copy } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from './SpecialOfferCard.styles';
const ModelImageContainer = themeStyles.apply(Box, 'ModelImageContainer');
const disclaimerText = 'U.S. model may be shown';
const ModelImage = ({ modelImage }) => (_jsxs(ModelImageContainer, { children: [_jsx(Image, { maxWidth: "auto", src: modelImage.src, alt: modelImage.alt }), _jsx(Copy, { size: "legal", textAlign: "center", children: disclaimerText })] }));
export default ModelImage;
